module.exports = __webpack_public_path__ + "img/m_top_happytable.e0e6e856.jpg";